// Headless export registration for the Info-View quadrant (single-output HC).
// The live iv Chart is reused as-is: it derives its own scores and plot radius from the
// answer and draws through the shared HC QuadrantChart, whose ChartContainer already
// carries the generic export hook. Key `qa` is the runtime question type -- `quadrant` is
// only the editor-schema alias for it (draft question mapping) and never reaches stats, so
// nothing is registered under that name. Same convention as the info-view bars entry, which
// serves its question types from the info-view component: an export draws the chart alone,
// with no controls and no table, which is what an info-view chart already is.

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import QuadrantChart from '@aytm/app/stats/page/question-views/info-view/components/charts/quadrant/Chart'

const quadrantEntry: ExportableChart = {
  Component: QuadrantChart,
  toProps: (data: any, params: any) => ({
    questionId: data.id || data.questionKey,
    questionKey: data.questionKey,
    // Chart reads format.title / xTitle / yTitle / plots / size -- keep it an object.
    format: data.format || {},
    answer: data.answer,
    // both are indexed without a guard (batches[0..1], questionVariants.length)
    batches: data.batches || [],
    questionVariants: data.questionVariants || [],
    xAxisLimits: data.xAxisLimits,
    yAxisLimits: data.yAxisLimits,
    colorTheme: data.colorTheme,
    chartLegendMode: params.chartLegendMode,
    features: data.features || {},
    onChartReady: undefined
  })
}

ExportableCharts.register('qa', quadrantEntry)
